import { Component, computed, input } from '@angular/core';

@Component({
  selector: 'app-pan-form-control',
  templateUrl: './pan-form-control.component.html',
  styleUrl: './pan-form-control.component.scss',
  standalone: false,
})
export class PanFormControlComponent {
  public class = input<string>('');

  public classes = computed(() => ['relative', 'mt-8', this.class()]);
}
